
    import '/app/index.js';

    const params = new URLSearchParams(window.location.search);
    const tenant = params.get('local_tenancy') || params.get('tenant');
    const hash = window.location.pathname.substring(1) || params.get('hash');
    const tectonics = new window.Tectonics(hash, null, tenant);
    tectonics.renderTo(document.getElementById('tectonics'));
  